import dayjs from 'dayjs';
import duration from 'dayjs/plugin/duration';

dayjs.extend(duration);

export function normalizeDuration(seconds: number | null): string | null {
  if (seconds == null) return null;

  const d = dayjs.duration(seconds, 'seconds');

  const years = d.years();
  if (years > 0) return years === 1 ? '1 ano' : `${years} anos`;

  const months = d.months();
  if (months > 0) return months === 1 ? '1 mês' : `${months} meses`;

  const days = d.days();
  if (days > 0) return days === 1 ? '1 dia' : `${days} dias`;

  const hours = d.hours();
  if (hours > 0) return hours === 1 ? '1 hora' : `${hours} horas`;

  const minutes = d.minutes();
  if (minutes > 0) return minutes === 1 ? '1 minuto' : `${minutes} minutos`;

  const secs = d.seconds();
  return secs === 1 ? '1 segundo' : `${secs} segundos`;
}
